export const windowOpen = (url: string) => {
  try {
    const result = window.open(url);

    if (!result) {
      window.location = url as any;
    }
  } catch (e) {
    console.error(e);
    alert("Please, turn off a pop up blocker");
  }
};
